import React from 'react'
import { Typography } from '@mui/material'
import { Box } from '@mui/material'

export default function PatientDashboardCategoryCriticalWarning(props) {
    return (
        <>
            <Typography sx={{ mt: 1, color: '#913831' }} variant="h5">
                {props.title}
            </Typography>
            <Box>
                {props.children}
            </Box>
        </>
    )
}
